module.exports = __webpack_public_path__ + "static/media/IssuersApp-logo-wide.e078d5ab.svg";